import { push } from '@takeshape/redux-little-router';
import type { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import type { PayloadAction } from 'typesafe-actions';
import { context } from '../../config';
import handleError from './handle-error';

/**
 * Like saga takeLatest but handles routine lifecycle
 */
export function takeLatestRoutine(
  actionName: string,
  handler: (action: PayloadAction<string, any>) => any,
  handleBasicErrors = true
) {
  function* doOnce(action: any): SagaIterator {
    const { meta } = action;
    const { redirectOnSuccess, redirectOnFailure } = meta || {};

    yield put({ type: `${actionName}_PENDING`, meta });

    try {
      const payload = yield call(handler, action);
      yield put({ type: `${actionName}_FULFILLED`, payload, meta });
      if (redirectOnSuccess) {
        yield put(push(redirectOnSuccess));
      }
    } catch (e) {
      if (context.tier === 'dev') {
        console.error(e);

        console.error('message', e.message, e.code);

        console.error('stack', e.stack);
      }

      const errorAction = handleError(e);
      if (handleBasicErrors && errorAction) {
        yield put(errorAction);
      } else if (redirectOnFailure) {
        yield put(push(redirectOnFailure));
      }

      yield put({
        type: `${actionName}_REJECTED`,
        error: true,
        payload: e,
        meta
      });
    }
  }

  return takeLatest(`${actionName}_REQUESTED`, doOnce);
}
